const n = "adyen-pe-amount-skeleton", o = n + "--has-margin", S = n + "--loading";
export {
  n as BASE_CLASS,
  S as LOADING_CLASS,
  o as MARGIN_CLASS
};
